import { PaladinCoreUtils } from '@paladin/core'
import DashboardLayout from './layouts/main.vue'
// import modules from '@modules'

export default function getRoutes(options) {
  const { store } = options

  const _baseRoutes = [
    {
      path: 'invite/:code?',
      name: 'invite',
      component: () => PaladinCoreUtils.lazyLoadView(import('./views/invite')),
      meta: {
        authRequired: true,
        beforeResolve(/* routeTo, routeFrom, */ next) {
          next()
          // store
          //   // Try to fetch the user's information by their username
          //   .dispatch('users/fetchUser', { username: routeTo.params.username })
          //   .then((user) => {
          //     // Add the user to the route params, so that it can
          //     // be provided as a prop for the view component below.
          //     routeTo.params.user = user
          //     // Continue to the route.
          //     next()
          //   })
          //   .catch(() => {
          //     // If a user with the provided username could not be
          //     // found, redirect to the 404 page.
          //     next({ name: '404', params: { resource: 'User' } })
          //   })
        },
      },
      props: (route) => ({
        code: route.params.code,
      }),
    },
    {
      path: 'notifications',
      name: 'notifications',
      component: () =>
        PaladinCoreUtils.lazyLoadView(import('./views/notifications')),
    },
    {
      path: 'dashboard',
      name: 'dashboard',
      component: () =>
        PaladinCoreUtils.lazyLoadView(import('./views/dashboard')),
      meta: {
        authRequired: true,
        // roleRequired: 'TenantAdmin', // ChiRhosOwner | TenantOwner | TenantAdmin
        menuSettings: {
          visible: true,
          order: 1,
          pluginArea: 'navigation.main', // navigation (navigation.notifications | navigation.events) | global-menu | user-menu | footer-menu
          showChildren: false,
          icon: 'columns',
          text: 'Dashboard',
          target: '/dashboard', // can be URL or route
        },
      },
    },
    {
      path: 'profile',
      name: 'profile',
      component: () => PaladinCoreUtils.lazyLoadView(import('./views/profile')),
      meta: {
        authRequired: true,
      },
      props: (/* route */) => ({
        identity: store.state.auth.identity || {},
        user: store.state.user || {},
      }),
    },
    {
      path: 'settings',
      name: 'settings',
      component: () =>
        PaladinCoreUtils.lazyLoadView(import('./views/settings')),
      props: (/* route */) => ({
        identity: store.state.auth.identity || {},
        user: store.state.user || {},
      }),
      redirect: (/* to */) => {
        return 'settings/profile'
      },
      children: [
        {
          path: 'profile',
          name: 'settings-profile',
          component: () =>
            PaladinCoreUtils.lazyLoadView(import('./views/settings/profile')),
          props: (/* route */) => ({
            identity: store.state.auth.identity || {},
            user: store.state.user || {},
          }),
          meta: {
            title: 'Settings',
          },
        },
        {
          path: 'account',
          name: 'settings-account',
          component: () =>
            PaladinCoreUtils.lazyLoadView(import('./views/settings/account')),
          props: (/* route */) => ({
            identity: store.state.auth.identity || {},
            user: store.state.user || {},
          }),
          meta: {
            title: 'Settings',
            authRequired: true,
          },
        },
      ],
    },
    {
      path: 'login',
      name: 'login',
      component: () => import(/* webpackChunkName: "browse" */ './views/login'),
      props: (/* route */) => ({
        user: store.state.user || {},
      }),
      // meta: {
      //   authRequired: false,
      //   menuSettings: {
      //     visible: false,
      //     order: 10,
      //     pluginArea: 'navigation.main', // navigation (navigation.notifications | navigation.events) | global-menu | user-menu | footer-menu
      //     showChildren: false,
      //     icon: 'sitemap',
      //     text: 'Login',
      //     target: '/login', // can be URL or route
      //   },
      // },
    },
  ]

  const _utilityRoutes = [
    {
      path: '401',
      name: '401',
      component: require('./views/_401').default,
      // Allows props to be passed to the 401 page through route
      // params, such as `resource` to define what wasn't found.
      props: true,
    },
    {
      path: '404',
      name: '404',
      component: require('./views/_404').default,
      // Allows props to be passed to the 404 page through route
      // params, such as `resource` to define what wasn't found.
      props: true,
    },
    // Redirect any unmatched routes to the 404 page. This may
    // require some server configuration to work in production:
    // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
    {
      path: '*',
      redirect: (to) => {
        // the function receives the target route as the argument
        if (to.path === '/') return 'dashboard'
        // return redirect path/location here.
        else return '404'
      },
    },
  ]

  return {
    path: '/',
    component: DashboardLayout,
    baseRoutes: _baseRoutes,
    utilityRoutes: _utilityRoutes,
  }
}
